import { useEffect, useState } from "react";
import { Col, Form, InputGroup, Modal, Row, Button, Table } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { connect, useDispatch } from "react-redux";
import ReactSelect from "react-select";
import { selectErrorStyles, selectStyles } from "../../../../components/Select/styles";
import { emptyOption } from "../../../../constants";
import { setLoading } from "../../../../redux/Loading/actions";
import { getConvenio, getConvenios, } from "../../../../redux/Sections/Convenios/actions";
import { fixNumber, formatDeuda, formatGastoFijo } from "../../../../utils/utils";
import BuscarDeudas from "./BuscarDeudas";

import SimulacionPlanPago from "./SimulacionPlanPago";
// import { convenioService } from "../../../../_services/convenios.service";
import Swal from "sweetalert2";
import { convenioService } from "../../../../_services/convenios.service";
import SelectPlan from "../../../../components/SelectPlan";
import pako from "pako";

const defaultCuotas = 15;

const EditConvenio = ({ show, handleClose, convenioId, getConvenio, data, loading, convCaracter, convEstados, convFormaPago, filters, convenio, abogados }) => {
  const dispatch = useDispatch();
  const { reset, register, handleSubmit, control, getValues, formState: { errors } } = useForm({});
  const [monto, setMonto] = useState({});
  const [montoInteres, setMontoInteres] = useState({});
  const [montoOrigen, setMontoOrigen] = useState({});
  const [total, setTotal] = useState(0);
  const [totalOrigen, setTotalOrigen] = useState({});
  const [totalInteres, setTotalInteres] = useState({});
  const [cuotas, setCuotas] = useState(15);
  const [showSimulacion, setShowSimulacion] = useState("");
  const [simulacionpp, setSimulacionpp] = useState("");
  const [caracter, setCaracter] = useState("");
  const [estado, setEstado] = useState("");
  const [formaPago, setFormaPago] = useState("");

  const [totalDeuda, setTotalDeuda] = useState(0);
  const [deudas, setDeudas] = useState([]);
  const [periodosList, setPeridosList] = useState([]);
  const [planes, setPlanes] = useState([]);

  const [tipoPlan, setTipoPlan] = useState("");
  const [anticipo, setAnticipo] = useState("");
  const [cuotasRafam, setCuotasRafam] = useState({});

  useEffect(() => {
    getConvenio(convenioId);
  }, [convenioId]);

  useEffect(() => {
    if (data) {
      data?.firma_caracter_nombre ? setCaracter(convCaracter?.find(e => e.nombre === data?.firma_caracter_nombre)) : "";
      data?.estado_id ? setEstado(convEstados?.find(e => e.id === +data?.estado_id)) : "";
      data?.frmpg_id ? setFormaPago(convFormaPago?.find(e => e.id === +data?.frmpg_id)) : "";

      reset({
        caracter: data?.firma_caracter_nombre ? convCaracter?.find(e => e.nombre === data?.firma_caracter_nombre)?.nombre : "",
        caracterotros: data?.firma_caracter_otros || "",
        dni: data?.frm_dni || "",
        nombre: data?.frm_nombre || "",
        telefono: data?.frm_tel || "",
        cel: data?.frm_cel || "",
        email: data?.frm_email || "",
        localidad: data?.frm_loc || "",
        direccion: data?.frm_dir || "",

        estado: data?.estado_id ? convEstados?.find(e => e.id === +data?.estado_id)?.id : "",
        estgstfijo: data?.estgstfijo || "",
        estporc: data?.estporc || "",
        otgastos: data?.otgastos || "",
        obsotgastos: data?.obsotgastos || "",
        formapago: data?.frmpg_id ? convFormaPago?.find(e => e.id === +data?.frmpg_id)?.id : "",
        montopago: data?.montopago || "",
        cuotaspago: data?.cuotaspago || "",
        obs: data?.obs || "",
        convenio: convenioId,
      });

      if (data?.planes) {
        let planes = JSON.parse(data.planes);
        setPlanes(planes);

        let montoValue = {};
        let montoInteresValue = {};
        let montoOrigenValue = {};
        planes.forEach((e) => {
          let name = `${e.imponible}-${e.recurso}`;

          montoValue[name] = montoValue[name] ? +Number(montoValue[name] + e.monto).toFixed(2) : +e.monto.toFixed(2);
          montoInteresValue[name] = montoInteresValue[name] ? +Number(montoInteresValue[name] + e.interes).toFixed(2) : +e.interes.toFixed(2);
          montoOrigenValue[name] = montoOrigenValue[name] ? +Number(montoOrigenValue[name] + e.origen).toFixed(2) : +e.origen.toFixed(2);
        });

        setMonto({ ...monto, ...montoValue });
      }
      if (data?.cuotas_plan) {
        let cuotas_plan = JSON.parse(data.cuotas_plan);

        setPeridosList(cuotas_plan.map((e) => {
          return {
            imponible: e.imponible.toString(),
            recurso: e.recurso.toString(),
            anio: e.anio.toString(),
            cuota: e.cuota.toString(),
            ANIO: e.anio.toString(),
            CUOTA: e.cuota.toString()
          };
        }));
      }
    }
  }, [data]);

  useEffect(() => {
    deudas.forEach(e => {
      if (e?.legal?.length) {
        if (!cuotas[e.recurso + "-" + e.imponible]) {
          setCuotas({ ...cuotas, [e.recurso + "-" + e.imponible]: defaultCuotas });
        }
      }
    });

  }, [deudas]);

  useEffect(() => {
    if (Object.values(monto).length) {
      let result = Object.keys(monto)?.reduce((prev, current) => {
        const [imponible, recurso] = current.split("-");

        if (prev[recurso + "-" + imponible]) {
          return {
            ...prev,
            [recurso + "-" + imponible]: +prev[recurso + "-" + imponible] + +monto[current]
          };
        }
        else {
          return {
            ...prev,
            [recurso + "-" + imponible]: +monto[current]
          };
        }
      }, {});

      let totalDeuda = Object.values(monto).reduce((a, b) => a + b);

      setTotalDeuda(fixNumber(totalDeuda));
      setTotal(result);
    }
  }, [monto]);

  const handleShowModal = (e) => {
    const { recurso, imponible } = e;

    if (!total[recurso + "-" + imponible]) return;
    if (!total[recurso + "-" + imponible]) return;
    if (tipoPlan[recurso + "-" + imponible] === "W2203" && !anticipo[recurso + "-" + imponible]) return;

    setSimulacionpp({
      ...e,
      total: total[recurso + "-" + imponible],
      cuotas: cuotas[recurso + "-" + imponible] || defaultCuotas,
      tipoPlan: tipoPlan[recurso + "-" + imponible],
      anticipo: anticipo[recurso + "-" + imponible],
    });
    setShowSimulacion(true);
  };

  const handleCloseModal = () => setShowSimulacion(false);

  const handleCuotas = (e) => {
    if (+e.target.value > 15) {
      e.target.value = 15;
      setCuotas({ ...cuotas, [e.target.name]: 15 });
    } else {
      setCuotas({ ...cuotas, [e.target.name]: e.target.value });
    }
  };

  const handlePeriodos = ({ e, valueMonto, periodo, imponible, recurso, valueOrigen, valueInteres }) => {
    if (e.target.checked) {
      setMonto({
        ...monto,
        [e.target.name]: monto[e.target.name] ? +Number(monto[e.target.name] + valueMonto).toFixed(2) : valueMonto
      });
      setMontoOrigen({
        ...montoOrigen,
        [e.target.name]: montoOrigen[e.target.name] ? +Number(montoOrigen[e.target.name] + valueOrigen).toFixed(2) : valueOrigen
      });
      setMontoInteres({
        ...montoInteres,
        [e.target.name]: montoInteres[e.target.name] ? +Number(montoInteres[e.target.name] + valueInteres).toFixed(2) : valueInteres
      });


      setPeridosList((prev) => [...prev, { ...periodo, imponible, recurso }]);

      setCuotasRafam({
        ...cuotasRafam,
        [e.target.name]: cuotasRafam[e.target.name] ? [...cuotasRafam[e.target.name], periodo] : [periodo]
      });
    }
    else {
      setMonto({
        ...monto,
        [e.target.name]: monto[e.target.name] ? +Number(monto[e.target.name] - valueMonto).toFixed(2) : 0
      });
      setMontoOrigen({
        ...montoOrigen,
        [e.target.name]: montoOrigen[e.target.name] ? +Number(montoOrigen[e.target.name] - valueOrigen).toFixed(2) : 0
      });
      setMontoInteres({
        ...montoInteres,
        [e.target.name]: montoInteres[e.target.name] ? +Number(montoInteres[e.target.name] - valueInteres).toFixed(2) : 0
      });
      setPeridosList((prev) => prev.filter((p) => !(p.imponible === imponible && p.recurso === recurso && p.ANIO === periodo.ANIO && p.CUOTA === periodo.CUOTA)));

      setCuotasRafam({
        ...cuotasRafam,
        [e.target.name]: cuotasRafam[e.target.name] ? cuotasRafam[e.target.name].filter((p) => !(p.ANIO === periodo.ANIO && p.CUOTA === periodo.CUOTA)) : []
      });
    }
  };

  const handleYear = ({ e, periodosData, valueMonto, deuda, imponible, recurso, valueOrigen, valueInteres }) => {
    if (e.target.checked) {
      let checkboxs = document.getElementsByName([e.target.name]);
      checkboxs.forEach(p => p.checked = true);

      setMonto({
        ...monto,
        [e.target.name]: +valueMonto
      });
      setMontoOrigen({
        ...montoOrigen,
        [e.target.name]: +valueOrigen
      });
      setMontoInteres({
        ...montoInteres,
        [e.target.name]: +valueInteres
      });
      setPeridosList((prev) => {
        return [...prev.filter((p) => !(p.imponible === imponible && p.recurso === recurso && p.ANIO === deuda.anio)), ...deuda.periodos.map(e => { return { ...e, imponible, recurso }; })];
      });

      setCuotasRafam({
        ...cuotasRafam,
        [e.target.name]: periodosData
      });
    }
    else {
      let checkboxs = document.getElementsByName([e.target.name]);
      checkboxs.forEach(p => p.checked = false);

      setMonto({
        ...monto,
        [e.target.name]: 0
      });
      setMontoOrigen({
        ...montoOrigen,
        [e.target.name]: 0
      });
      setMontoInteres({
        ...montoInteres,
        [e.target.name]: 0
      });
      setPeridosList((prev) => prev.filter((p) => !(p.imponible === imponible && p.recurso === recurso && p.ANIO === deuda.anio)));

      setCuotasRafam({
        ...cuotasRafam,
        [e.target.name]: []
      });
    }
  };


  const handleSelect = (e, name) => {
    if (name === "caracter") {
      setCaracter(e);
    }
    else if (name === "estado") {
      setEstado(e);
    }
    else {
      setFormaPago(e);
    }
  };

  const handleRemove = (item) => {
    setDeudas(prev => {
      return prev.filter(e => !(e.recurso === item.recurso && e.imponible === item.imponible));
    });

    setTotal(prev => {
      delete prev[item.recurso + "-" + item.imponible];
      return prev;
    });
    setTotalOrigen(prev => {
      delete prev[item.recurso + "-" + item.imponible];
      return prev;
    });
    setTotalInteres(prev => {
      delete prev[item.recurso + "-" + item.imponible];
      return prev;
    });
    setCuotas(prev => {
      delete prev[item.recurso + "-" + item.imponible];
      return prev;
    });

    setPeridosList((prev) => prev.filter((p) => !(p.imponible === item.imponible && p.recurso === item.recurso)));

    if (Object.values(monto).length) {
      let result = Object.keys(monto)?.reduce((prev, current) => {
        const [imponible, recurso] = current.split("-");

        if (recurso === item.recurso && imponible === item.imponible) {
          return prev;
        }
        else {
          return {
            [current]: monto[current]
          };
        }
      }, {});
      let resultInteres = Object.keys(monto)?.reduce((prev, current) => {
        const [imponible, recurso] = current.split("-");

        if (recurso === item.recurso && imponible === item.imponible) {
          return prev;
        }
        else {
          return {
            [current]: montoInteres[current]
          };
        }
      }, {});
      let resultOrigen = Object.keys(monto)?.reduce((prev, current) => {
        const [imponible, recurso] = current.split("-");

        if (recurso === item.recurso && imponible === item.imponible) {
          return prev;
        }
        else {
          return {
            [current]: montoOrigen[current]
          };
        }
      }, {});

      setMonto(result);
      setMontoOrigen(resultOrigen);
      setMontoInteres(resultInteres);
    }

    if (Object.values(cuotasRafam).length) {
      let result = Object.keys(cuotasRafam)?.reduce((prev, current) => {
        const [imponible, recurso] = current.split("-");

        if (recurso === item.recurso && imponible === item.imponible) {
          return prev;
        }
        else {
          return {
            [current]: cuotasRafam[current]
          };
        }
      }, {});

      setCuotasRafam(result);
    }
  };

  const onSubmit = async (newData) => {
    try {
      dispatch(setLoading(true));

      let planes = [];
      let cuotasArray = [];

      if (Object.keys(total)?.length) {
        for (const element in total) {
          if (total[element]) {
            const [recurso, imponible] = element.split("-");
            const contribuyente = deudas.find(e => e.recurso === e.recurso && imponible === e.imponible)?.contribuyente;

            const tipoCuotas = {
              W2113: 6,
              W2112: 3,
              W2200: 3,
              W2201: 1,
              W2203: 6,
              ABLT: cuotas[[recurso + "-" + imponible]] || defaultCuotas,
              "SHANT_6": 6,
              "SHANT_12": 12,
            };

            planes.push({
              r: recurso,
              i: imponible,
              i50: 0,
              c: tipoPlan[recurso + "-" + imponible] ? tipoCuotas[tipoPlan[recurso + "-" + imponible]] : (cuotas[[recurso + "-" + imponible]] || defaultCuotas),
              m: total[element],
              origen: `${totalOrigen[element]}`,
              intereses: `${totalInteres[element]}`,
              cnt: contribuyente?.APYNOM
            });
          }
        }
      }

      if (periodosList?.length) {
        cuotasArray = periodosList.map((e) => {
          return {
            r: e.recurso,
            i: e.imponible,
            a: e.anio || e.ANIO,
            c: e.cuota || e.CUOTA,
          };
        });
      }

      if (planes?.flat()?.length) {
        newData.planes = JSON.stringify(planes.flat());
      }
      if (cuotasArray?.flat()?.length) {
        newData.cuotas = pako.gzip(JSON.stringify(JSON.stringify(cuotasArray.flat())));
      }

      newData.convenio = convenioId;
      newData.montopago = newData.montopago ? newData.montopago : "0";
      newData.cuotaspago = newData.cuotaspago ? newData.cuotaspago : "0";
      newData.otgastos = newData.otgastos ? newData.otgastos : "0";
      newData.estporc = estado.porcentual ? estado.porcentual : "0";
      newData.titulo = caracter;

      const prevData = {
        caracter: data?.firma_caracter_nombre ? convCaracter?.find(e => e.nombre === data?.firma_caracter_nombre)?.nombre : "",
        caracterotros: data?.firma_caracter_otros || "",
        dni: data?.frm_dni || "",
        nombre: data?.frm_nombre || "",
        telefono: data?.frm_tel || "",
        cel: data?.frm_cel || "",
        email: data?.frm_email || "",
        localidad: data?.frm_loc || "",
        direccion: data?.frm_dir || "",
        estado: data?.estado_id ? convEstados?.find(e => e.id === +data?.estado_id)?.id : "",
        estgstfijo: +data?.estgstfijo || "",
        estporc: data?.estporc || "",
        otgastos: data?.otgastos || "",
        obsotgastos: data?.obsotgastos || "",
        formapago: data?.frmpg_id ? convFormaPago?.find(e => e.id === +data?.frmpg_id)?.id : "",
        montopago: data?.montopago || "",
        cuotaspago: data?.cuotaspago || "",
        obs: data?.obs,
        planes: data?.planes,
        cuotas: data?.cuotas_plan,
      };

      for (const value in prevData) {
        if (newData[value] === prevData[value]) {
          delete newData[value];
        }
      }

      const response = await convenioService.editConvenio(newData);

      if (response?.success) {
        dispatch(getConvenios(filters));
        dispatch(setLoading(false));
        Swal.fire({
          title: "Exito",
          icon: "success",
          // willClose: () => handleClose() 
        });
      }
      else {
        dispatch(setLoading(false));
        Swal.fire("Error", "Ocurrio un error intentelo nuevamente", "error");
      }
    }
    catch (err) {
      dispatch(setLoading(false));
      console.log(err);
    }
  };


  return (
    <Modal
      animation={false}
      show={!loading && !!show}
      onHide={handleClose}
      size="xl"
    >
      <Modal.Header closeButton>
        <Modal.Title>Ver Convenio</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row style={{ overflowX: "auto" }}>
          <div className="buscar-deudas">
            <BuscarDeudas setDeudas={setDeudas} deudas={deudas} handleRemove={handleRemove} convenio={convenio} planes={planes} />
          </div>

          {deudas?.length ? deudas.map(({ imponible, recurso, legal }, i) => {
            const findAbogado = abogados.find((e) => legal.length && e.codexterno === legal[legal.length - 1].LEGAL);

            return (
              <div key={imponible + recurso + i} style={{ width: "100%", padding: "2rem" }}>
                {legal?.length ? (
                  <Table
                    className="subtable legal-subtable"
                    striped
                    bordered
                    hover
                  >
                    <tbody>
                      <tr>
                        <td colSpan={3} className="subtable-subtitulo">Abogado {`${findAbogado?.apellido} ${findAbogado?.nombre}`.toUpperCase()} ({legal[legal.length - 1].LEGAL}). Recurso: {recurso || ""} - Imponible: {imponible || ""}</td>
                      </tr>
                      <tr>
                        <td colSpan={3} className="subtable-subtitulo">Períodos Legal</td>
                      </tr>
                      <tr>
                        <td className="subtable-key">Año</td>
                        <td className="subtable-key">Período</td>
                        <td className="subtable-key">Monto</td>
                      </tr>
                      {formatDeuda(legal)?.length ?
                        formatDeuda(legal).map((deuda, indx) => {
                          let name = `${imponible}-${recurso}`;

                          return (
                            <tr key={"plan" + indx + recurso}>
                              <td className="subtable-key">
                                <div className="d-flex align-items-center ">
                                  <Form.Check
                                    name={name}
                                    value={deuda.anio}
                                    onChange={(e) => handleYear({ e, periodosData: deuda.periodos, valueMonto: deuda.monto.toFixed(2), deuda, imponible, recurso, valueOrigen: deuda.origen.toFixed(2), valueInteres: deuda.interes.toFixed(2) })}
                                  />
                                  <Form.Label className="" >{deuda.anio}</Form.Label>
                                </div>
                              </td>
                              <td className="d-flex" style={{ height: 54 }}>
                                {
                                  deuda?.periodos?.length ? deuda.periodos.map((periodo, i) => {
                                    let checked = periodosList.some((p) => (p.imponible === imponible && p.recurso === recurso && p.ANIO === periodo.ANIO && p.CUOTA === periodo.CUOTA));

                                    return (
                                      <div className="d-flex align-items-center ml-3" key={deuda.anio + periodo?.CUOTA + i}>
                                        <Form.Check
                                          value={periodo?.CUOTA}
                                          name={name}
                                          className=""
                                          onChange={(e) => handlePeriodos({ e, valueMonto: +Number(periodo?.TOTAL).toFixed(2), periodo, imponible, recurso, valueOrigen: +Number(periodo?.ORIGEN).toFixed(2), valueInteres: +Number(periodo?.INTERES).toFixed(2) })}
                                          checked={checked}
                                        />
                                        <Form.Label className="" >{periodo?.CUOTA}</Form.Label>
                                      </div>
                                    );
                                  })
                                    : null
                                }
                              </td>
                              <td className="subtable-key">$ {monto[name] ? monto[name] : 0}</td>
                            </tr>
                          );
                        }) : null}
                      <tr>
                        <td colSpan={2} className="subtable-key" style={{ textAlign: "right" }}>Total</td>
                        <td className="subtable-key">$ {total[recurso + "-" + imponible] ? total[recurso + "-" + imponible] : 0}</td>
                      </tr>
                      <tr>
                        <td colSpan={3} className="subtable-key" style={{ textAlign: "right" }}>
                          <SelectPlan
                            recurso={recurso}
                            imponible={imponible}
                            handleShowModal={handleShowModal}
                            handleCuotas={handleCuotas}
                            setCuotas={setCuotas}
                            setTipoPlan={setTipoPlan}
                            tipoPlan={tipoPlan}
                            setAnticipo={setAnticipo}
                            anticipo={anticipo}
                            total={total[recurso + "-" + imponible] ? total[recurso + "-" + imponible] : 0}
                            type={""}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                ) : null}

              </div>
            );
          }) : null}
        </Row>

        {showSimulacion ? <SimulacionPlanPago show={showSimulacion} handleClose={handleCloseModal} data={simulacionpp} /> : null}

        <Form className="edit-convenio" onSubmit={handleSubmit(onSubmit)}>
          <Form.Group>
            <Row className="mb-1">
              <Col>
                <Form.Label className="mb-2">Se presenta en carácter de</Form.Label>
                <Controller
                  name="caracter"
                  control={control}
                  rules={{ required: "El campo es obligatorio" }}
                  render={({ field: { onChange } }) => {
                    return (
                      <ReactSelect
                        options={convCaracter?.length ? [emptyOption, ...convCaracter] : [emptyOption]}
                        value={caracter || ""}
                        onChange={(e) => {
                          handleSelect(e, "caracter");
                          return onChange(e?.value);
                        }}
                        styles={selectStyles}
                      />
                    );
                  }}
                />
                {errors.caracter ? (
                  <div
                    className="invalid"
                    style={{
                      fontSize: "80%",
                      color: "#dc3545",
                      marginTop: 4
                    }}
                  >
                    {errors.caracter.message}
                  </div>
                ) : ""}
              </Col>
              <Col>
                <Form.Label className="mb-2">Otros</Form.Label>
                <Form.Control
                  name="caracterotros"
                  {...register("caracterotros")}
                />
              </Col>
            </Row>
            <Row className="mb-1">
              <Col>
                <Form.Label className="mb-2">DNI</Form.Label>
                <Form.Control
                  name="dni"
                  className={`${errors.dni ? "is-invalid" : ""}`}
                  {...register("dni", { required: "El campo es obligatorio" })}
                />
                <Form.Control.Feedback type="invalid">{errors.dni?.message}</Form.Control.Feedback>
              </Col>
              <Col>
                <Form.Label className="mb-2">Apellido y Nombre</Form.Label>
                <Form.Control
                  name="nombre"
                  className={`${errors.nombre ? "is-invalid" : ""}`}
                  {...register("nombre", { required: "El campo es obligatorio" })}
                />
                <Form.Control.Feedback type="invalid">{errors.nombre?.message}</Form.Control.Feedback>
              </Col>
            </Row>
            <Row className="mb-1">
              <Col>
                <Form.Label className="mb-2">Teléfono</Form.Label>
                <Form.Control
                  name="telefono"
                  className={`${errors.telefono ? "is-invalid" : ""}`}
                  {...register("telefono", { required: "El campo es obligatorio" })}
                />
                <Form.Control.Feedback type="invalid">{errors.telefono?.message}</Form.Control.Feedback>
              </Col>
              <Col>
                <Form.Label className="mb-2">Celular</Form.Label>
                <Form.Control
                  name="cel"
                  className={`${errors.cel ? "is-invalid" : ""}`}
                  {...register("cel")}
                />
                <Form.Control.Feedback type="invalid">{errors.cel?.message}</Form.Control.Feedback>
              </Col>
              <Col>
                <Form.Label className="mb-2">E-Mail</Form.Label>
                <Form.Control
                  name="email"
                  className={`${errors.email ? "is-invalid" : ""}`}
                  {...register("email")}
                />
                <Form.Control.Feedback type="invalid">{errors.email?.message}</Form.Control.Feedback>

              </Col>
            </Row>
            <Row className="mb-1">
              <Col>
                <Form.Label className="mb-2">Localidad</Form.Label>
                <Form.Control
                  name="localidad"
                  className={`${errors.localidad ? "is-invalid" : ""}`}
                  {...register("localidad", { required: "El campo es obligatorio" })}
                />
                <Form.Control.Feedback type="invalid">{errors.localidad?.message}</Form.Control.Feedback>

              </Col>
              <Col>
                <Form.Label className="mb-2">Dirección</Form.Label>
                <Form.Control
                  name="direccion"
                  className={`${errors.direccion ? "is-invalid" : ""}`}
                  {...register("direccion", { required: "El campo es obligatorio" })}
                />
                <Form.Control.Feedback type="invalid">{errors.direccion?.message}</Form.Control.Feedback>

              </Col>
            </Row>
            <Row className="mb-1">
              <Col>
                <Form.Label className="mb-2">Estado</Form.Label>
                <Controller
                  name="estado"
                  control={control}
                  rules={{ required: "El campo es obligatorio" }}
                  render={({ field: { onChange } }) => {
                    return (
                      <ReactSelect
                        options={convEstados?.length ? [emptyOption, ...convEstados] : [emptyOption]}
                        onChange={(e) => {
                          handleSelect(e, "estado");
                          return onChange(e?.value);
                        }}
                        value={estado ? estado : ""}
                        styles={selectStyles}
                      />
                    );
                  }}
                />
                {errors.estado ? (
                  <div
                    className="invalid"
                    style={{
                      fontSize: "80%",
                      color: "#dc3545",
                      marginTop: 4
                    }}
                  >
                    {errors.estado.message}
                  </div>
                ) : ""}
              </Col>
            </Row>
            <Row className="mb-1">
              <Col>
                <Form.Label className="mb-2">Hon.s/Deuda</Form.Label>
                <InputGroup>
                  <InputGroup.Prepend>
                    <InputGroup.Text>$</InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control
                    value={fixNumber(totalDeuda * (+estado?.porcentual || 0))}
                    disabled
                  />
                </InputGroup>
              </Col>
              <Col>
                <Form.Label className="mb-2">Gasto Fijo</Form.Label>
                <InputGroup>
                  <InputGroup.Prepend>
                    <InputGroup.Text>$</InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control
                    name="estgstfijo"
                    value={totalDeuda ? formatGastoFijo(totalDeuda, estado) : 0}
                    {...register("estgstfijo", { value: totalDeuda ? formatGastoFijo(totalDeuda, estado) : 0 })}
                    disabled
                  />
                </InputGroup>
              </Col>
            </Row>
            <Row className="mb-1">
              <Col>
                <Form.Label className="mb-2">Otros Gastos</Form.Label>
                <InputGroup>
                  <InputGroup.Prepend>
                    <InputGroup.Text>$</InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control
                    type="number"
                    name="otgastos"
                    {...register("otgastos")}
                  />
                </InputGroup>
              </Col>
              <Col className="d-flex align-items-end">
                <Form.Label className="mb-2">Obs Otros Gastos</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={1}
                  name="obsotgastos"
                  {...register("obsotgastos")}
                />
              </Col>
            </Row>
            <Row className="mb-1">
              <Col>
                <Form.Label className="mb-2">Total Hon.</Form.Label>
                <InputGroup>
                  <InputGroup.Prepend>
                    <InputGroup.Text>$</InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control
                    value={fixNumber((totalDeuda * +estado?.porcentual) + (+estado.gastofijo || 0) + (+getValues("otgastos") || 0))}
                    disabled
                  />
                </InputGroup>
              </Col>
            </Row>
            <Row className="mb-1">
              <Col>
                <Form.Label className="mb-2">Forma de Pago</Form.Label>
                <Controller
                  name="formapago"
                  rules={{
                    required: "El campo es obligatorio"
                  }}
                  control={control}
                  render={({ field: { onChange } }) => {
                    return (
                      <ReactSelect
                        options={convFormaPago?.length ? [emptyOption, ...convFormaPago] : [emptyOption]}
                        onChange={(e) => {
                          handleSelect(e, "formapago");
                          return onChange(e?.value);
                        }}
                        value={formaPago ? formaPago : ""}
                        styles={errors.formapago ? selectErrorStyles : selectStyles}
                      />
                    );
                  }}
                />
                {errors.formapago ? (
                  <div
                    className="invalid"
                    style={{
                      fontSize: "80%",
                      color: "#dc3545",
                      marginTop: 4
                    }}
                  >
                    {errors.formapago.message}
                  </div>
                ) : ""}
              </Col>
            </Row>
            <Row className="mb-1">
              {formaPago.nombre === "Mixto" ? (
                <Col>
                  <Form.Label className="mb-2">Monto</Form.Label>
                  <InputGroup>
                    <InputGroup.Prepend>
                      <InputGroup.Text>$</InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control
                      name="montopago"
                      {...register("montopago")}
                    />
                  </InputGroup>
                </Col>
              ) : null}
              {formaPago.nombre === "En Cuotas" || formaPago.nombre === "Mixto" ? (
                <Col>
                  <Form.Label className="mb-2">Cuotas</Form.Label>
                  <Form.Control
                    name="cuotaspago"
                    {...register("cuotaspago")}
                  />
                </Col>
              ) : null}
            </Row>
            <Row className="mb-1">
              <Col>
                <Form.Label className="mb-2">Observaciones</Form.Label>
                <Form.Control
                  as={"textarea"}
                  name="obs"
                  {...register("obs")}
                />
              </Col>
            </Row>
          </Form.Group>
          <Row className="mb-1">
            <Col className="d-flex justify-content-end">
              <Button type="submit" className="custom-button" style={{ maxWidth: 190 }}>Grabar Convenio</Button>
            </Col>
            <Col>
              <Button variant="danger" onClick={handleClose} className="danger-button" style={{ maxWidth: 190 }}>Cancelar Convenio</Button>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
    </Modal >
  );

};


const mapStateToProps = (state) => {
  return {
    data: state.dashboard.convenio,
    convCaracter: state.dashboard.convCaracter,
    convEstados: state.dashboard.convEstados,
    convFormaPago: state.dashboard.convFormaPago,
    loading: state.dashboard.loading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getConvenio: (id) => dispatch(getConvenio(id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditConvenio);